export default (function (_ref) {
  var colors = _ref.colors;
  return {
    container: {
      position: 'relative',
      fontSize: '15px',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      alignItems: 'center',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 0 0 0'
      },
      '& > div:first-of-type': {
        padding: '13px 0 9px'
      }
    },
    discountStripe: {
      '&:after': {
        position: 'absolute',
        content: '""',
        width: '6px',
        height: '100%',
        backgroundColor: colors.primary,
        top: 0,
        right: 0,
        marginLeft: '10px'
      },
      '& > div': {
        marginRight: '12px'
      }
    },
    container__underline: {
      borderBottom: "1px solid ".concat(colors.gray)
    },
    container__last: {
      borderBottom: 'none'
    },
    container__inverseColors: {
      borderColor: colors.white,
      color: colors.white
    },
    column__right: {
      marginLeft: 'auto',
      textAlign: 'right'
    },
    bold: {
      fontWeight: 500
    },
    loading: {
      filter: 'blur(3px)'
    },
    subtitle: {
      fontSize: '12px',
      color: colors.additional
    },
    subtitle__inverseColors: {
      color: colors.monotone2
    },
    tooltip: {
      verticalAlign: 'middle',
      marginBottom: '-6px',
      marginTop: '-4px'
    },
    discount: {
      fontSize: '12px',
      textDecorationLine: 'line-through',
      color: colors.monotone3
    }
  };
});